import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAdzM1ckRyi0iB0er6XJaddj7lMdT3dWYs",
    authDomain: "thedojosite-1e02d.firebaseapp.com",
    projectId: "thedojosite-1e02d",
    storageBucket: "thedojosite-1e02d.appspot.com",
    messagingSenderId: "863836546745",
    appId: "1:863836546745:web:cd8c82ba7c0b0bdc7c9d68"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services 
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()
// timestamp
const timestamp = firebase.firestore.Timestamp

export  { projectFirestore, projectAuth, timestamp, projectStorage}
